import yup from 'utils/yup';

export const initialImportHolidayData = {
  id: '',
  country: null as any,
  year: {} as any,
  users: [] as Array<any>,
  holidays: [] as Array<any>,
  group_ids: [],
};

export const importHolidayValidationSchema = yup.object().shape({
  country: yup.object().nullable().required(),
  year: yup.object().nullable().required(),
});
